import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { TextMaskService } from "@bayclubs/ui-text-mask";

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AmountPickerComponent),
    multi: true
};



@Component({
    selector: 'app-amount-picker',
    templateUrl: './amount-picker.component.html',
    styleUrls: ['./amount-picker.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    standalone: false
})
export class AmountPickerComponent implements OnInit, ControlValueAccessor {


    public valueInner: string = null;

    @Input() public isRequired : boolean = false;


    constructor(public mask: TextMaskService) {
        this.value = null;
    }

    ngOnInit() {
    }

    //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    //From ControlValueAccessor interface
    writeValue(value: string) {
        this.valueInner = value
        if (value !== this.value) {
            this.value = value;
        }
    }

    get value(): any {

        return this.valueInner;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.valueInner) {
            this.valueInner = v;
            this.onChangeCallback(this.valueInner);
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }


    showClear() {
        return this.value;
    }

    onClear() {
        this.value = null;
    }

    public isInvalid(){
        return this.isRequired && !this.valueInner;
    }

}
